import {isValidDate} from '../../../../services';
import {getNonemptyMembers} from './getNonemptyMembers';
import {MemberInput} from './types';

export const validateMembers = (members: MemberInput[]): boolean => {
  const nonEmpty = getNonemptyMembers(members);
  const valid =
    nonEmpty.length > 0 &&
    nonEmpty.reduce(
      (acc, m) =>
        acc && isValidDate(m.startDate) && (m.numberInfo?.isValid ?? false),
      true,
    );

  return valid;
};
